import RpIcon from "@/components/RpIcon";
import { InputAdornment, TextField, useTheme, InputLabel,styled,Stack } from "@mui/material";
import React from 'react';

const Label = styled(InputLabel)(({ theme }) => ({
  fontFamily: "Urbanist",
  fontSize: "13px",
  marginBottom: "6px",
  fontWeight: 400,
  color: theme.palette.text.primary,
}));
const StyleTextField = styled(TextField)(({ theme }) => ({
  ".MuiInputBase-root":{
    "fieldset":{
      borderRadius:"6px"
    }
  }
}));

const AppTextField = ({clearable, onClear, type, endAdornment, autoComplete, label, ...props}) => {
  const theme = useTheme();
  let inputProps = props.InputProps || {};
  if (autoComplete) {
    inputProps = {
      ...inputProps,
      autoComplete,
    };
  }

  let endChilren = [];
  if (endAdornment != null) {
    endChilren = [endAdornment,];
  }
  if (props.value && clearable && !props.disabled) {
    endChilren.push(<RpIcon color={theme.palette.text.primary} icon="close" size={15} onClick={onClear} clickable/>);
  }
  if (endChilren.length) {
    inputProps.endAdornment = <InputAdornment position="end">
      {endChilren.map((child, idx) => <React.Fragment key={idx}>{child}</React.Fragment>)}
    </InputAdornment>;
  }

  return (
    <Stack width={"100%"}>
      <Label>{label}</Label>
      <StyleTextField size="medium" type={type} {...props} InputProps={inputProps}/>
    </Stack>
  );
};

export default AppTextField;